import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`HostJane's e-commerce platform lets Users receive luxury Harrods Hampers as gifts from the famous London store. You can choose to have HostJane deliver the hamper to your address for free or get a full credit to your HostJane Balance. After a 48-hour wait, you can withdraw the credit and buy the hamper yourself from Harrods.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      